module.exports = __webpack_public_path__ + "img/italy.612e617f.svg";